import {
  ColumnDefinition,
  OuiBoxComponent,
  OuiRecordDatasource as OuiDatasource,
  OuiDataTableComponent,
  OuiDialogComponent,
  OuiDialogHeaderComponent,
  OuiGridComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DisplayValueComponent } from '../../components/display-value/display-value.component';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { PageComponent } from '../../components/page/page';
import { DeviceCareCenter } from '../../models/device-care-center.model';
import { DeviceCareCenterService } from '../../services/device-care-center/device-care-center.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-device-care-center',
  standalone: true,
  imports: [
    OuiBoxComponent,
    OuiStackComponent,
    OuiDataTableComponent,
    OuiDialogComponent,
    OuiDialogHeaderComponent,
    OuiGridComponent,
    OuiTextComponent,
    OuiRowComponent,
    DownloadButtonComponent,
    DisplayValueComponent,
    PageComponent,
  ],
  templateUrl: './device-care-center.component.html',
})
export class DeviceCareCenterPage extends BasePageComponent {
  protected deviceCareCenterService = inject(DeviceCareCenterService);

  deviceCareCenter!: OuiDatasource<DeviceCareCenter>;

  deviceCareCenterColumns: ColumnDefinition<DeviceCareCenter>[] = [
    {
      columnDef: 'code',
      header: 'Code',
    },
    {
      columnDef: 'name',
      header: 'Name',
    },
    {
      columnDef: 'state',
      header: 'State',
    },
    {
      columnDef: 'country',
      header: 'Country',
    },
  ];

  showDialog = signal<boolean>(false);
  selectedDeviceCareCenter = signal<DeviceCareCenter | undefined>(undefined);

  constructor() {
    super();

    effect(() => {
      this.deviceCareCenter = new OuiDatasource(
        this.deviceCareCenterService.deviceCareCenters.value(),
      );
    });
  }

  handleRowClick(deviceCareCenter: DeviceCareCenter) {
    this.selectedDeviceCareCenter.set(deviceCareCenter);
    this.showDialog.set(true);

    this.deviceCareCenterService
      .getDeviceCareCenterById(deviceCareCenter.code)
      .subscribe((details) => {
        console.log(details);
        this.selectedDeviceCareCenter.set(details);
      });
  }
}
